import Content from '../../content.js';

namespace('IO.Views.Users', function (exports) {
  'use strict';

  var DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    New = Content.extend({
      jstTemplate: 'users/capabilities_details',

      dom: {
        USER_CAPABILITIES_TEMPLATE: '#capabilities_template',
        API_ACCESS: '.api_access',
        SELECT2_FIELD: 'select.select2select.assigned-customers',
        USER_SITE: '.user_site',
        ASSIGNED_CUSTOMERS: '.assigned_customers',
        ROLE: '#role',
        ROLE_DETAILS: '#role-description',
      },

      events: function () {
        var events = {};

        events['change ' + this.dom.USER_CAPABILITIES_TEMPLATE] =
          '_userCapabilitiesTemplateChanged';
        events['change ' + this.dom.API_ACCESS] = '_toggleTokenAPI';
        events['change ' + this.dom.ROLE] = '_showRoleDetails';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      onDestroy: function () {
        this.dynamicForm.remove();
      },

      error: function () {
        this.render();
      },

      render: function () {
        this.dynamicForm = new DynamicGroupForm({
          el: this.$el,
          inverse: true,
        });
        this.dynamicForm.render();

        $(this.dom.SELECT2_FIELD).select2();

        this._showRoleDetails({ target: $(this.dom.ROLE)[0] });
      },

      beforeRender: function () {
        this.roleRetrieval = new UserRoleRetrieval();
        this.primaryCustomerRetrieval = new PrimaryCustomerRetrieval();
      },

      _showRoleDetails: function (e) {
        var data = {},
          capabilities,
          item,
          category,
          i;

        if (
          typeof role_capabilities === 'undefined' ||
          typeof e.target === 'undefined'
        ) {
          // eslint-disable-line camelcase
          return true;
        }

        capabilities = role_capabilities[e.target.value]; // eslint-disable-line camelcase

        for (i in capabilities) {
          item = capabilities[i];
          category = item.split('_')[0];
          if (typeof data[category] === 'undefined') {
            data[category] = [];
          }
          data[category].push(item.split('_')[1]);
        }

        $(this.dom.ROLE_DETAILS).html(this.renderTemplate({ data: data }));
      },

      _userCapabilitiesTemplateChanged: function () {
        this._toggleAdminCustomers();
        this._toggleTokenAPI();
      },

      _toggleAdminCustomers: function () {
        if ($(this.dom.USER_CAPABILITIES_TEMPLATE).val() === 'admin') {
          $(this.dom.ASSIGNED_CUSTOMERS).removeClass('hidden');
          $(this.dom.USER_SITE).addClass('hidden');
        } else {
          $(this.dom.ASSIGNED_CUSTOMERS).addClass('hidden');
          $(this.dom.USER_SITE).removeClass('hidden');
        }
      },

      _toggleTokenAPI: function () {
        var apiEnabled = $(this.dom.API_ACCESS).find('#api_access0')[0].checked,
          apiPassword = $('.api_password');

        if (apiEnabled) {
          apiPassword.show();
        } else {
          apiPassword.hide();
        }
      },
    });

  exports.New = New;
});
